function SalesDashboard() {
    return (
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">Sales Dashboard</h1>
        {/* Add your dashboard content here */}
      </div>
    );
  }
  
  export default SalesDashboard;